import React from 'react';
import { ArmchairIcon, HammerIcon, LibraryIcon, RulerIcon } from 'lucide-react';
import { SNAPSHOT, type SnapshotIcon } from '../../data/woodworking';
const ICONS: Record<SnapshotIcon, React.ComponentType<{
  className?: string;
}>> = {
  projects: ArmchairIcon,
  volumes: LibraryIcon,
  dimensions: RulerIcon,
  rights: HammerIcon
};

/** Compact value snapshot directly under the hero. */
export function ValueStrip() {
  return <section aria-label="What's included" className="border-b border-ivory-line bg-ivory-deep" data-id="element-249" data-mp="38b3ayqt30n6z">
      <ul className="mx-auto grid w-full max-w-6xl grid-cols-2 px-5 sm:px-8 lg:grid-cols-4" data-id="element-250" data-mp="34bb20czs0f13">
        {SNAPSHOT.map((item, index) => {
        const Icon = ICONS[item.icon];
        return <li key={item.label} className={`flex flex-col items-center gap-2 px-2 py-4 text-center sm:flex-row sm:justify-center sm:gap-3 sm:py-5 sm:text-left ${index % 2 === 1 ? 'border-l border-ivory-line' : ''} ${index >= 2 ? 'border-t border-ivory-line lg:border-t-0' : ''} ${index === 2 ? 'lg:border-l' : ''}`} data-id="element-251" data-mp="2ujf0eryhe6s4" data-mpi={index}>
              <Icon className="h-5 w-5 shrink-0 text-forest" aria-hidden data-id="element-252" data-mp="1fcbr0i9gah5b" />
              <span className="text-balance text-[0.74rem] font-semibold uppercase leading-tight tracking-[0.08em] text-ink sm:text-[0.82rem]" data-id="element-253" data-mp="11i16ye8efb5l">
                {item.label}
              </span>
            </li>;
      })}
      </ul>
    </section>;
}